import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=0ffd3f8e&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=0ffd3f8e&prod&scoped=true&lang=css"
import style1 from "./userInfo.vue?vue&type=style&index=1&id=0ffd3f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffd3f8e",
  null
  
)

export default component.exports